import * as Styled from './styled'
import TtsItemSpeakerVelocity from './Velocity'
import TtsItemSpeakerToggler from './ToggleSpeaker'
import TtsDeleteButton from './Delete'
import TtsDownloadButton from './Download'
import { memo } from 'react'

interface IProps {
  isActive: boolean
}

const TtsItemControlsButtons: React.FC<IProps> = ({ isActive }) => {
  return (
    <Styled.TtsControlsButtonsWrapper $isActive={isActive}>
      <Styled.TtsItemLeftControlsWrapper>
        <TtsItemSpeakerToggler />
        <Styled.TtsControlsDivider />
        <TtsItemSpeakerVelocity />
      </Styled.TtsItemLeftControlsWrapper>
      <Styled.TtsItemRightControlsWrapper>
        <TtsDownloadButton />
        <TtsDeleteButton />
      </Styled.TtsItemRightControlsWrapper>
    </Styled.TtsControlsButtonsWrapper>
  )
}

export default memo(TtsItemControlsButtons)
